import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormsService } from '../forms.service';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';
import { DailyReportService } from '../../../../daily-report.service';

@Component({
    selector: 'app-general-question-form',
    templateUrl: './general-question-form.component.html',
    styleUrls: ['./general-question-form.component.scss'],
    standalone: false
})
export class GeneralQuestionFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: FormGroup = new FormGroup({});
  @Input() currentQuestion: any;
  @Input() currentIndex: any;
  @Input() responseOptions: any;
  selectedMediaFiles: any = [];
  displayCommentSection = false;
  questionFrom: FormGroup = new FormGroup({});
  videoToBeDeletedFromMuxDb = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private formsService: FormsService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private dailyReportService: DailyReportService,
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentQuestion']) {
      this.displayCommentSection = false;
      this.selectedMediaFiles = [];
      this.questionFrom = this.getFormGroup(this.form, this.currentQuestion?.id);
      const questionFormFieldValue = this.questionFrom.controls.field_values.value;

      if (this.currentIndex === 0 &&
        (questionFormFieldValue === 'N/A' || questionFormFieldValue === 'Yes' || questionFormFieldValue === 'Pass')) {
        this.questionFrom.addControl('applyToAll', new FormControl(), { emitEvent: false });
      }

      const tempPictureData = this.getPictures();
      const tempVideosData = this.getVideos();

      const allNewItems = [...tempPictureData, ...tempVideosData];

      allNewItems.forEach(item => {
        const existingItem = this.selectedMediaFiles.find(ei => ei.id === item.id);

        if (!existingItem) {
          this.selectedMediaFiles.push(item);
        }
      });

      this.cdRef.detectChanges();
    }
  }

  ngOnInit(): void {
    this.formsService.addComment
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.displayCommentSection = true;
      });

    this.questionFrom?.controls?.['field_values']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.questionFrom.removeControl('applyToAll', { emitEvent: false });

        if ((data === 'N/A' || data === 'Yes' || data === 'Pass') && this.currentIndex === 0) {
          this.questionFrom.addControl('applyToAll', new FormControl(), { emitEvent: false });

          this.questionFrom?.controls?.['applyToAll']?.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe((appliedToAll) => {
              if (appliedToAll) {
                this.setFieldValues(data);
              }
            });

        } else {
          this.questionFrom.removeControl('applyToAll', { emitEvent: false });
        }
      });

    this.commonService.uploadedFilesInfoOnPopup
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        data = JSON.parse(JSON.stringify(data));
        const items = Array.isArray(data) ? data : [data];

        items.forEach(eachItem => {
          if (eachItem?.['fileType'] === 'picture' || eachItem?.['fileType'] === 'document') {
            let pictures = this.questionFrom?.get('pictures')?.value || '[]';
            pictures = JSON.parse(pictures);
            pictures.push(eachItem);
            this.questionFrom?.get('pictures')?.setValue(JSON.stringify(pictures));
          }

          if (eachItem?.['fileType'] === 'video') {
            let videos = this.questionFrom?.get('videos')?.value || '[]';
            videos = JSON.parse(videos);
            videos.push(eachItem);
            this.questionFrom?.get('videos')?.setValue(JSON.stringify(videos));
          }
        });

        const tempPictureData = this.getPictures() ?? [];
        const tempVideosData = this.getVideos() ?? [];
        const allNewItems = [...tempPictureData, ...tempVideosData];
        allNewItems.forEach(item => {
          const existingItem = this.selectedMediaFiles.find(ei => ei.id === item.id);

          if (!existingItem) {
            this.selectedMediaFiles.push(item);
          }
        });

        this.selectedMediaFiles = [...this.selectedMediaFiles];
      });

    this.form?.controls?.['questions']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.dailyReportService.upDateGeneralFormSummary.next(data);
      });

    this.cdRef.detectChanges();
  }

  getFormGroup(form: FormGroup, controlName: string): any {
    if (form && form.get('questions') instanceof FormGroup) {
      const questions = form.get('questions') as FormGroup;

      for (const controlKey of Object.keys(questions.controls)) {
        if (controlKey.includes(`_${controlName}`)) {
          return questions.get(controlKey) as FormGroup;
        }
      }
    }
  }

  getPictures() {
    const pictures = this.questionFrom?.get('pictures')?.value || '[]';
    return JSON.parse(pictures);
  }

  getVideos() {
    const videos = this.questionFrom?.get('videos')?.value || '[]';
    return JSON.parse(videos);
  }

  deletePicture(pic) {
    if (pic.fileType === 'picture') {
      let pictures = this.getPictures();

      pictures = pictures?.filter(o => o.id !== pic.id);
      this.selectedMediaFiles = this.selectedMediaFiles?.filter(o => o.id !== pic.id);
      this.questionFrom?.get('pictures')?.setValue(JSON.stringify(pictures));
    }

    if (pic.fileType === 'video') {
      let videos = this.getVideos();

      videos = videos?.filter(o => o.id !== pic.id);
      this.selectedMediaFiles = this.selectedMediaFiles?.filter(o => o.id !== pic.id);
      this.questionFrom?.get('videos')?.setValue(JSON.stringify(videos));
      this.videoToBeDeletedFromMuxDb.push(pic.id);
    }
  }

  setFieldValues(value) {
    const questionsGroup = this.form.get('questions') as FormGroup;
    if (Object.keys(questionsGroup.controls).length > 0) {
      Object.keys(questionsGroup.controls).forEach(key => {
        const nestedGroup = questionsGroup.get(key) as FormGroup;
        if (nestedGroup && nestedGroup.get('field_values')) {
          nestedGroup?.get('field_values')?.setValue(value, { emitEvent: false });
        }
      });
    }
  }


  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
